import { render, staticRenderFns } from "./data-instruction-popup.html?vue&type=template&id=447a270c&scoped=true&external"
import script from "./data-instruction-popup.js?vue&type=script&lang=js&external"
export * from "./data-instruction-popup.js?vue&type=script&lang=js&external"
import style0 from "./data-instruction-popup.scss?vue&type=style&index=0&id=447a270c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447a270c",
  null
  
)

export default component.exports